export class AssetServiceReq {
    assetId?: number;
    plant?:number;
    location?:number;
    assetCode?:string;
    plantId?:number;
  assetType?: string;
  assetCategory?: string;

}